import { render, staticRenderFns } from "./internal-training.vue?vue&type=template&id=ecc79744"
import script from "./internal-training.vue?vue&type=script&lang=ts"
export * from "./internal-training.vue?vue&type=script&lang=ts"
import style0 from "./internal-training.vue?vue&type=style&index=0&id=ecc79744&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports